import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import {Add, Check} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import DialogTitle from '../../../../components/DialogTitle'
import {PALETTE} from '../../../../styles/paletteV3'
import {ExternalLinks} from '../../../../types/constEnums'

const IconBlock = styled('div')({
  padding: '0px 8px 0 8px'
})

const StyledAddIcon = styled(Add)({
  color: PALETTE.SKY_500,
  width: '24px',
  height: '24px'
})

const StyledCheckIcon = styled(Check)({
  color: PALETTE.SUCCESS_LIGHT,
  width: '24px',
  height: '24px'
})

const ContentWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  border: `1px solid ${PALETTE.SLATE_500}`,
  borderRadius: '4px',
  padding: '4px 8px 4px '
})

const SSOEnabledLabelBlock = styled('div')({
  display: 'flex',
  flexDirection: 'column'
})

const SubTitle = styled(DialogTitle)({
  color: PALETTE.SLATE_700,
  fontSize: '16px',
  padding: 0
})

const SSOEnabledLabel = styled('span')({
  color: PALETTE.SLATE_700,
  fontSize: '14px'
})

const ContactLink = styled('a')({
  fontSize: '14px',
  fontWeight: 600,
  color: PALETTE.SKY_500,
  '&:focus, &:active': {
    color: PALETTE.SKY_500
  }
})





const OrgAuthenticationSSOFrame = (props) => {
  const {samlRef} = props
  const saml = useFragment(
    graphql`
      fragment OrgAuthenticationSSOFrame_saml on SAML {
        id
        domains
      }
    `,
    samlRef
  )
  const disabled = !saml
  const domains = _nullishCoalesce(_optionalChain([saml, 'optionalAccess', _ => _.domains]), () => ( []))

  return (
    _jsx('div', { className: "px-6 pb-8" , children: 
      _jsxs(ContentWrapper, { children: [
        _jsx(IconBlock, { children: disabled ? _jsx(StyledAddIcon, {} ) : _jsx(StyledCheckIcon, {} )})
        , _jsxs(SSOEnabledLabelBlock, { children: [
          _jsx(SubTitle, { children: disabled ? 'Enable SSO' : 'SSO Enabled'})
          , _jsxs(SSOEnabledLabel, { children: [
            _jsx(ContactLink, {
              href: `${ExternalLinks.CONTACT}?subject=${
                disabled ? 'Enable SSO' : 'Update Email Domains'
              }`,
              title: 'Contact customer success to enable SSO',
 children: "Contact customer success"

            }), ' '
            , disabled ? 'to enable SSO' : 'to update email domains'
          ]})
          , _jsx('div', { className: 'flex gap-2 pt-2 pb-1 empty:hidden', children: 
            domains.map((domain) => {
              return (
                _jsx('div', {

                  className: 
                    'bg w-max rounded-full bg-slate-200 px-3 py-1 text-xs font-semibold text-slate-800 select-none'
                  ,
 children: 
                  domain
                }, domain)
              )
            })
          })
        ]})
      ]})
    })
  )
}

export default OrgAuthenticationSSOFrame
